import styled, { css } from 'styled-components';
import { up } from '@/themes';

/*
 * Typography scale, mirrored from the marketing site. Sizes are in px on
 * purpose: the root font size here is fluid (16-18px), so rem/em would drift.
 */

export const eyebrowStyle = css`
  color: var(--primary);
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.025em;
  line-height: 20px;
  margin: 0;
  text-transform: uppercase;
`;

export const heroTitleStyle = css`
  color: var(--foreground);
  font-size: 36px;
  font-weight: 600;
  letter-spacing: -0.025em;
  line-height: 40px;
  margin: 0;
  text-wrap: balance;

  ${up.sm} {
    font-size: 48px;
    line-height: 1;
  }

  ${up.lg} {
    font-size: 60px;
  }
`;

export const sectionTitleStyle = css`
  color: var(--foreground);
  font-size: 30px;
  font-weight: 600;
  letter-spacing: -0.025em;
  line-height: 36px;
  margin: 0;
  text-wrap: balance;

  ${up.sm} {
    font-size: 36px;
    line-height: 40px;
  }
`;

export const cardTitleStyle = css`
  color: var(--foreground);
  font-size: 18px;
  font-weight: 600;
  letter-spacing: normal;
  line-height: 28px;
  margin: 0;
`;

export const leadStyle = css`
  color: var(--muted-foreground);
  font-size: 18px;
  line-height: 28px;
  margin: 0;
  text-wrap: pretty;
`;

export const bodyStyle = css`
  color: var(--foreground);
  font-size: 16px;
  line-height: 24px;
  margin: 0;
`;

export const mutedStyle = css`
  color: var(--muted-foreground);
  font-size: 14px;
  line-height: 20px;
  margin: 0;
`;

export const gradientTextStyle = css`
  background-image: var(--gradient-brand);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
`;

/** Small uppercase label above a heading. */
export const Eyebrow = styled.p`
  ${eyebrowStyle};
`;

/** The page's single h1. */
export const HeroTitle = styled.h1`
  ${heroTitleStyle};
`;

/** Section heading (h2). */
export const SectionTitle = styled.h2`
  ${sectionTitleStyle};
`;

/** Card / step heading (h3). */
export const CardTitle = styled.h3`
  ${cardTitleStyle};
`;

/** Intro paragraph under a heading. `$large` is the hero size (20px from 640px up). */
export const Lead = styled.p`
  ${leadStyle};

  ${({ $large }) =>
    $large &&
    css`
      ${up.sm} {
        font-size: 20px;
      }
    `};
`;

/** Default body copy. */
export const Text = styled.p`
  ${bodyStyle};
`;

/** Secondary, smaller copy. */
export const Muted = styled.p`
  ${mutedStyle};
`;

/** Inline text painted with the brand gradient. */
export const GradientText = styled.span`
  ${gradientTextStyle};
`;

/** Visually hidden, still read by screen readers. */
export const VisuallyHidden = styled.span`
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;
